import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=5fa6e664&scoped=true&"
import script from "./WithdrawModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=5fa6e664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6e664",
  null
  
)

export default component.exports